import React, { useEffect } from 'react';
import { useHistory, useParams, Link } from 'react-router-dom';
import { routeConfig } from '../shared/common/constant';
import { ResetPassword } from '../shared/common/graphqlQuery';
import { useMutationHook } from '../shared/hooks/useMutationHook';
import { Button, Form, Input, Card, Row, message } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { validateNameMessages } from '../shared/hooks/utils';
import AccountPageShowBrand from '../shared/components/accountPageShowBrand/accountPageBrand';

const ResetPasswordComponent = () => {
    const { confirmToken } = useParams<any>();
    const history = useHistory();
    const goToLastPage = () => { history.push(routeConfig.login.path); }

    const onSubmitted = (result: any) => {
        // handleAuth(result.confirmUser);
        message.success(result.resetPassword);
        goToLastPage();
    }

    const onFinish = (values: any) => {
        if (confirmToken && !loading) {
            callMutation({ variables: { confirmationToken: confirmToken, newPassword: values.password } })
        }
    };

    const onError = ({ graphQLErrors, networkError }: any) => {
        message.error(graphQLErrors[0].message);
    }

    const { callMutation, loading } = useMutationHook(ResetPassword, onSubmitted, onError);

    return (
        <div className="center">
            <div className="card">
                <AccountPageShowBrand />
                <Card title="Reset Password" bordered={false} className='loginForm'>
                    <Form name="basic" onFinish={onFinish} validateMessages={validateNameMessages} validateTrigger='onSubmit' initialValues={null}>
                        <Form.Item name="password" rules={[{ required: true, whitespace: true }]}>
                            <Input.Password size="large" placeholder="New Password" />
                        </Form.Item>
                        <Form.Item>
                            <Button size="large" type="primary" htmlType="submit" style={{ width: '100%' }}>
                                {loading ? <LoadingOutlined style={{ fontSize: '20px' }} /> : 'Reset Password'}
                            </Button>
                        </Form.Item>
                    </Form>
                </Card>
            </div>
        </div>
    );
}
export default ResetPasswordComponent

